module.exports = __webpack_public_path__ + "img/mi-soul.d1470ae0.png";